<script setup lang="ts">
import './assets/style.scss'
import type { PropType } from 'vue'
import { computed } from 'vue'
import { useConfirm, VIcons } from '@/shared/ui'
import { useSearchPresetDelete } from './../model/api.ts'
import type { SearchPresetItem } from '@/widgets/GlobalSearch/model/type.ts'
import { useTranslate } from '@/shared/lib'

const props = defineProps({
  presets: {
    type: Array as PropType<SearchPresetItem[]>,
    required: true,
  },
  presetId: {
    type: Number as PropType<number | null>,
    default: null,
  },
})

const { remove } = useSearchPresetDelete()
const { show } = useConfirm()
const { trs } = useTranslate()
const emits = defineEmits(['deleted'])

const currentPreset = computed(() => props.presets.find((p) => p.id === props.presetId) ?? null)

/**
 * Показывает диалог подтверждения удаления выбранного пресета.
 * Кнопка недоступна, если пресет не выбран.
 */
const deleteHandler = () => {
  if (!currentPreset.value?.id) return
  show({
    title: trs('itf.delete_preset', { name: currentPreset.value.name }),
    confirmFunc: async () => {
      await remove(currentPreset.value!.id!)

      emits('deleted')
    },
  })
}
</script>

<template>
  <VTooltip location="top" :text="$t('itf.delete')">
    <template #activator="{ props }">
      <VBtn
        v-bind="props"
        variant="tonal"
        :disabled="!currentPreset || !currentPreset.id"
        color="error"
        @click="deleteHandler"
      >
        <VIcons type="delete" />
      </VBtn>
    </template>
  </VTooltip>
</template>
